import { useState } from 'react'

import { Label } from '@radix-ui/react-label'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import type { DialogProps } from '@/dialogs/types'
import { openDialog } from '@/models/dialogs.ts'
import { useAccountingAdditionalCostTypes } from '@/modules/accounting/hooks/useAccountingAdditionalCostTypes.ts'
import type { AccountingCostBody } from '@/modules/accounting/types.ts'
import { AdditionalCostTypeInput } from '@/modules/accounting/ui/AdditionalCosts/AdditionalCostTypeInput.tsx'

interface Props extends DialogProps {
  data: AccountingCostBody
}

export const AddAdditionalCostDialog = ({ isOpen, onClose, data }: Props) => {
  const { data: costTypes } = useAccountingAdditionalCostTypes()
  const costType = costTypes?.find(({ id }) => id === data.typeId)
  const [selectedTypeId, setSelectedTypeId] = useState<number | null>(
    costType?.id || null,
  )
  const handleSubmit = async () => {
    openDialog({
      type: DIALOG_TYPE.ADDITIONAL_COST_DETAILS,
      data: {
        ...data,
        typeId: selectedTypeId!,
      },
    })
    onClose()
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Set Additional Cost</Dialog.Title>
        <Dialog.Description className="text-center">
          Select the type of the additional cost
        </Dialog.Description>
      </Dialog.Header>

      <div className="mt-5">
        <Label className="mb-1 block text-sm">Type</Label>
        <AdditionalCostTypeInput
          value={selectedTypeId}
          onSelect={setSelectedTypeId}
        />
      </div>

      <Dialog.Footer className="grid grid-cols-2 gap-3">
        <Button
          onClick={onClose}
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={!selectedTypeId}
        >
          Continue
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
